import React, { useEffect, useState } from 'react';
import { pageService } from 'services/page.service';

const useFAQ = () => {
    const [faqData, setFaqData] = useState({});

    const handleApi = async () => {
        try {
            const response = await pageService.Faq();
            setFaqData(response?.data?.data);
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        handleApi();
    }, []);

    return { faqData };
}

export default useFAQ;